import { Button, Container, Title } from '@/components'

import useClickWithScroll from '@/utils/browser/useClickWithScroll'

import styles from './styles.module.scss'
import Image from 'next/image'
import bannerUrl from '/public/images/ricardo-lapa.webp'

const Lapa = () => {
  const { isHomePage, onClickItem } = useClickWithScroll()

  return (
    <section className={`fgt-section ${styles.lapa}`}>
      <Container>
        <Title Tag="h2" alignText="center">
          METODOLOGIA <span>LAPA TEAM</span> COM RESULTADOS
        </Title>
        <p className="fgt-subtitle">
          O método Lapa Team já mudou a vida de milhares de pessoas, seja você
          também uma delas!
        </p>
        <div className={styles.content}>
          <Image
            className={styles.image}
            src={bannerUrl}
            width={360}
            height={410}
            alt="Ricardo Lapa, conheça a metodologia Lapa Team"
          />
          <div className={styles.about}>
            <ul className={styles.items}>
              <li className={styles.item}>
                <p>
                  <strong>Método Lapa Team</strong> combina{' '}
                  <strong>treinamento funcional e intensivo</strong> que permite
                  o alcance de resultados extraordinários
                </p>
              </li>

              <li>
                <p className={styles.item}>
                  <strong>RICARDO LAPA</strong>, fundador e criador da Academia
                  Foguete e já treinou mais de 300 mil alunos em 56 países.
                </p>
              </li>

              <li>
                <p className={styles.item}>
                  <strong>Revolucionou o mercado Fitness</strong> nos últimos 10
                  ANOS.
                </p>
              </li>

              <li>
                <p className={styles.item}>
                  Treinador de pessoas famosas como <strong>Jade Picon</strong>,{' '}
                  <strong>Bruna Griphao</strong>, <strong>Malu Borges</strong>,{' '}
                  <strong>Rachel Apollonio</strong>,{' '}
                  <strong>Thiago Martins</strong> e muitos outros.
                </p>
              </li>
            </ul>

            <div className="fgt-section__action">
              <Button
                id="btn-section-lapa-team"
                variant="primary"
                className={styles.button}
                onClick={() => {
                  onClickItem('comparePlans')
                }}
              >
                QUERO ENTRAR PARA O TIME
              </Button>
            </div>
          </div>
        </div>
      </Container>
    </section>
  )
}

export default Lapa
